<template>
  <section class="accordion">   
    <button 
      class="btn accordion__button"
      @click="toggleMoreText"
      :class="{ 'less': showMoreText, 'accordion__button--mobile-top': isMobile }"
    >
      <div class="accordion__headline">{{ headline }}</div>
      <div class="accordion__cta-container" v-if="!isMobile">
        <svg class="accordion__svg" width="31" height="31" xml:space="preserve" style="enable-background:new 0 0 31 31" viewBox="0 0 31 31">
          <path 
            class="accordion__path accordion__path--v" 
            d="M15 0h1v31h-1z" 
            fill="red"
            :class="{ 'less': showMoreText }"
          />
          <path class="accordion__path" d="M0 15h31v1H0z" fill="white"/>
        </svg>
        <div 
          class="accordion__cta"
          :class="{ 'less': showMoreText }"
        >
          {{ cta }}
        </div>
      </div>
    </button> 
    <div 
        class="accordion__content" 
        ref="overviewcontainer"
        :class="{ 'accordion--bb': border === 'bottom' && !isMobile }"
      >
        <div 
          class="accordion__text" 
          v-html="text" 
          ref="overview"
          :class="{ active : showMoreText }"
        >
        </div>      
    </div>
    <button 
      v-if="isMobile"
      class="btn accordion__button accordion__button--mobile-bottom"
      @click="toggleMoreText"
      :class="{ 'less': showMoreText, 'accordion--bb': border === 'bottom' && isMobile }"
    >
      <div class="accordion__cta-container">
        <svg class="accordion__svg" width="31" height="31" xml:space="preserve" style="enable-background:new 0 0 31 31" viewBox="0 0 31 31">
          <path 
            class="accordion__path accordion__path--v" 
            d="M15 0h1v31h-1z" 
            fill="red"
            :class="{ 'less': showMoreText }"
          />
          <path class="accordion__path" d="M0 15h31v1H0z" fill="white"/>
        </svg>
        <div 
          class="accordion__cta"
          :class="{ 'less': showMoreText }"
        >
          {{ cta }}
        </div>
      </div>
    </button> 
  </section>
</template>
  
  <script>
  import { isMobile } from 'mobile-device-detect';
    export default {
      props: {
        headline: { type: String },
        text: { type: String },
        cta: { type: String },
        border: { type: String },
      },
      data() {
        return {
          showMoreText: true,
          originalHeight: null,
          isMobile: isMobile,
        };
      },
      mounted() {
        this.calculateOriginalHeight();
        this.toggleMoreText();
        // window.addEventListener('resize', this.calculateOriginalHeight);
      },
      beforeDestroy() {
        window.removeEventListener('resize', this.calculateOriginalHeight);
      },
      methods: {
        calculateOriginalHeight() {
          this.originalHeight = this.$refs.overview.clientHeight + 'px';
          this.$refs.overviewcontainer.style.height = this.originalHeight;
        },
        toggleMoreText() {
          this.$refs.overviewcontainer.style.height = this.showMoreText ? '0' : this.originalHeight;
          this.showMoreText = !this.showMoreText;
        },
      },
    };
  </script>

  <style lang="scss">
  .accordion {
    grid-column: center-start / center-end;
    color: white;
    &__button {
      position: relative;
      border-top: 1px solid white;
      grid-column: center-start / center-end;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: white;
      padding: var(--gutter-mobile-v) var(--gutter-mobile-h);
      cursor: pointer;     
      width: 100%; 
      &--mobile {
        &-top {
          padding-bottom: .4rem;
        }
        &-bottom {
          padding-top: .4rem;
          border-top: none;
        }
      }
      @media (min-width: 1025px) {
        padding: 6.4rem;
      }
    }
    &__headline {
      font-size: 7vw;
      font-family: var(--fontSerifRg);
      text-transform: uppercase;
      @media (min-width: 1025px) {
        font-size: 5.4rem;
        font-size: 3.6vw;
      }
    }
    &__svg {
      display: block;
      height: 2rem;
      width: 2rem;
      margin-right: .5rem;
      @media (min-width: 1025px) {
        height: 3rem;
        width: 3rem;
        margin-right: 1rem;
      }
      &--small {
        height: 1.6rem;
        width: 1.6rem;
        margin-right: .5rem;
      }
    }
    &__cta {
      font-family: var(--fontSerifRg);
      font-size: 2rem;
      @media (min-width: 1025px) {
        font-size: 3rem;
      }
      &:after {
        content: '(All)';
        font-family: var(--fontSerifIt);
      }
      &.less {
        &:after {
          content: '(Less)';
        }
      }
      &-container {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    &__path {
      fill: white;
      &--v {
        transition: transform .6s ease, opacity .2s ease;
        transform-origin: center bottom;
        transform-origin: center center;
        &.less {
          transition: transform .6s ease, opacity .2s .3s ease;
          transform: scaleY(0);
          opacity: 0;
        }
      }
      &--black {
        fill: black;
      }
    }
    &__content {
      grid-column: center-start / center-end;
      overflow: hidden;
      transition: height .75s ease;
    }
    &__text {
      padding: var(--gutter-mobile-h) var(--gutter-mobile-h) var(--gutter-mobile-v);
      font-size: 1.6rem;
      line-height: 150%;
      @media (min-width: 1025px) {
        padding: 0 50% 6.4rem 6.4rem;
      }
    }
    &--bb {
      border-bottom: 1px solid white;
    }
  }
  
  </style>